var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5C8.9233 21.5 6.89323 20.8842 5.16652 19.7304C3.4398 18.5767 2.09399 16.9368 1.29927 15.0182C0.504549 13.0996 0.296615 10.9884 0.701759 8.95156C1.1069 6.91475 2.10693 5.04383 3.57538 3.57538C5.04383 2.10693 6.91475 1.1069 8.95156 0.701759C10.9884 0.296615 13.0996 0.504549 15.0182 1.29927C16.9368 2.09399 18.5767 3.4398 19.7304 5.16652C20.8842 6.89323 21.5 8.9233 21.5 11C21.4969 13.7838 20.3897 16.4528 18.4212 18.4212C16.4528 20.3897 13.7838 21.4969 11 21.5Z",
    fill: "#00CC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1255 7.71686C14.2645 7.57598 14.4508 7.49802 14.6442 7.49979C14.8375 7.50155 15.0225 7.58288 15.1592 7.72628C15.296 7.86968 15.3735 8.06366 15.3752 8.26644C15.3769 8.46923 15.3026 8.66459 15.1682 8.81046L15.1656 8.8133L9.96021 14.2724C9.89177 14.3443 9.81024 14.4016 9.72075 14.4406C9.63115 14.4796 9.53509 14.4997 9.43808 14.4998C9.24287 14.4997 9.05555 14.4185 8.91734 14.2739L6.83223 12.0872C6.6979 11.9413 6.62359 11.7459 6.62527 11.5431C6.62695 11.3404 6.70451 11.1464 6.84124 11.003C6.97797 10.8596 7.16294 10.7782 7.3563 10.7765C7.54966 10.7747 7.73594 10.8527 7.87503 10.9936L7.87774 10.9963L9.43804 12.6327L14.1255 7.71686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/ToastSuccessIcon.ca3802fc35784b64d1e8d51445533a4c.svg";
export { ForwardRef as ReactComponent };